import { ProductionListSelectorType, ProductionListSelectorWithRowsInfoType } from '@/types/app-types'

import { MAX_PRODUCTIONS, MLB_OPENING_DAY_STRING } from './constants'

const findHomeOpenerByName = (
    performerName: string,
    production: ProductionListSelectorType | ProductionListSelectorWithRowsInfoType,
) => {
    const { production: analyticsProduction } = production.analytics
    const homePerformerName = analyticsProduction.performers.find(({ master }) => master)?.name
    return homePerformerName === performerName && analyticsProduction.name.includes(MLB_OPENING_DAY_STRING)
}

/* istanbul ignore next */
export const updateHomeOpenerProduction = (
    performerName: string,
    productions?: ProductionListSelectorType[],
    productionsWithFormat?: ProductionListSelectorWithRowsInfoType[],
): void => {
    const findHomeOpener = (production: ProductionListSelectorType | ProductionListSelectorWithRowsInfoType) =>
        findHomeOpenerByName(performerName, production)

    if (productions) {
        const homeOpenerProduction = productions.find(findHomeOpener)
        if (homeOpenerProduction) {
            homeOpenerProduction.isHomeOpener = true
            homeOpenerProduction.name = homeOpenerProduction.name.replace(MLB_OPENING_DAY_STRING, '')
        }
    } else if (productionsWithFormat) {
        const homeOpenerProduction = productionsWithFormat.find(findHomeOpener)
        if (homeOpenerProduction) {
            homeOpenerProduction.isHomeOpener = true
            homeOpenerProduction.title = homeOpenerProduction.title.replace(MLB_OPENING_DAY_STRING, '')
        }
    }
}

/* istanbul ignore next */
export const filterMlbNearbyProductions = (
    productions: ProductionListSelectorType[] | undefined,
): ProductionListSelectorType[] | undefined => {
    return productions
        ?.filter(
            (production) =>
                !production.name.includes('(Includes Tickets to All Regular Season Home Games)') &&
                !production.name.includes('(Exhibition)'),
        )
        ?.slice(0, MAX_PRODUCTIONS)
}
